export default __webpack_public_path__ + "static/media/monitor.32adbe0a.gif";